module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.76672d82e03a8cae1530.js");
};